module.exports = __webpack_public_path__ + "img/bg_学生学习.1548b1eb.png";